(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

export function noBignumber() {
  throw new Error('No "bignumber" implementation available');
}
export function noFraction() {
  throw new Error('No "fraction" implementation available');
}
export function noMatrix() {
  throw new Error('No "matrix" implementation available');
}
export function noIndex() {
  throw new Error('No "index" implementation available');
}
export function noSubset() {
  throw new Error('No "matrix" implementation available');
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(noBignumber, "noBignumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/utils/noop.js");
  reactHotLoader.register(noFraction, "noFraction", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/utils/noop.js");
  reactHotLoader.register(noMatrix, "noMatrix", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/utils/noop.js");
  reactHotLoader.register(noIndex, "noIndex", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/utils/noop.js");
  reactHotLoader.register(noSubset, "noSubset", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/utils/noop.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();